import {Store, createStore} from 'vuex';
import BaseMapStylesDialogModule, {
  BaseMapStylesState
} from "../.././base_map_dialog/store/modules/BaseMapStylesDialogModule";
import RecordingMapModule, { RecordingMapState } from "./modules/RecordingMapModule";
import BaseMapDataPOIsModule, { BaseMapDataPOIsState } from "../../base_map_dialog/store/modules/BaseMapDataPOIsModule";
import BaseMapDataOverlaysModule, { BaseMapDataOverlaysState } from "../../base_map_dialog/store/modules/BaseMapDataOverlaysModule";
import WaypointDialogModule, { WaypointDialogState } from "../../waypoint_dialog/store/module/WaypointOptionsDialogModule";

export interface RootState {
  mapStyles: BaseMapStylesState
  recordingMap: RecordingMapState
  mapDataOverlays: BaseMapDataOverlaysState
  mapDataPOIs: BaseMapDataPOIsState
  waypoints: WaypointDialogState
}

const store: Store<RootState> = createStore({
  modules: {
    mapStyles: BaseMapStylesDialogModule,
    recordingMap: new RecordingMapModule(),
    mapDataOverlays: BaseMapDataOverlaysModule,
    mapDataPOIs: BaseMapDataPOIsModule,
    waypoints: WaypointDialogModule,
  }
})

export default store;
